export const imageBaseApi = window.APP_CONFIG.api2.baseapi;

export const onshoreUrl = window.APP_CONFIG.onshoreUrl;
export const offshoreUrl = window.APP_CONFIG.offshoreUrl;
export const smartkampus = window.APP_CONFIG.smartkampusUrl;
